import { render } from "./KidsAges.vue?vue&type=template&id=43954856"
import script from "./KidsAges.vue?vue&type=script&lang=js"
export * from "./KidsAges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__